import React from 'react';

export const name = 'flag-FI';

export const FlagFI = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_1_3)">
      <g mask="url(#mask0_1_3)">
        <path
          d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
          fill="#EEEEEE"
        />
        <path
          d="M23.8969 10.4344H9.38906V0.285919C8.29706 0.527925 7.24453 0.92242 6.2625 1.45779V10.4344H0.103128C-0.0324584 11.4737 -0.0324584 12.5263 0.103128 13.5656H6.2625V22.5422C7.24453 23.0775 8.29706 23.472 9.38906 23.7141V13.5656H23.8969C24.0323 12.5263 24.0323 11.4737 23.8969 10.4344Z"
          fill="#0052B4"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_1_3">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
